import { h } from 'preact'

export function BlogCard({ blog }) {
  const articleImage = blog.image_alt || blog.image

  return (
    <a href={blog.url} className="group/blog-card flex flex-col gap-y-1" aria-label={`Read more about ${blog.title}`}>
      <div className="w-full aspect-1/1 bg-neutral-medium overflow-hidden children:size-full children:object-cover children:group-hover/blog-card:scale-[1.025] children:transition-all">
        {articleImage?.src && (
          <img
            src={articleImage.src}
            alt={articleImage.alt || blog.title}
            className="size-full object-cover group-hover/blog-card:scale-[1.025] transition-all"
            loading="lazy"
            width={articleImage.width}
            height={articleImage.height}
          />
        )}
      </div>

      <div className="flex flex-col gap-y-1 md:pr-1">
        <h3 className="paragraph-m font-bold">{blog.title}</h3>
        {blog.excerpt && (
          <div className="w-fit richtext paragraph-b">
            {blog.excerpt}
          </div>
        )}
        <div className="btn btn-primary btn-s btn-text w-fit link-line lined group-hover/blog-card:opacity-50">
          <span>Read More</span>
        </div>
      </div>
    </a>
  )
}
